import { combineReducers } from 'redux';

import byId from './byId/reducer';
import goalAdding from './goalAdding/reducer';
import goalsFetching from './goalsFetching/reducer';

export default combineReducers({
  byId,
  goalAdding,
  goalsFetching
});




/** WEBPACK FOOTER **
 ** ./src/members/state/goals/reducer.js
 **/